import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csrelationbwclass(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
 <title>C# association tutorial For Beginners</title>
 <meta name="description" content="C# association tutorial for beginners.association in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# association," />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-association" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Q-what is Association in C#?</h1>
    <div className="first">
        <a href="/csharp-multilevel-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-overloading">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


<h2 className="headings">Q-Method Start in Example of association in C# ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">school</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">void </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1">("</span>
            <span className="qwerty-5">teaching</span>
            <span className="qwerty-1">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">void </span>
            <span className="qwerty-6">students </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-3">.WriteLine</span>
            <span className="qwerty-1">("</span>
            <span className="qwerty-3">learn</span>
            <span className="qwerty-1">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-5">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-4">void main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-1">("</span>
            <span className="qwerty-3">start </span>
            <span className="qwerty-7">method</span>
            <span className="qwerty-1">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">school</span>
            <span className="qwerty-7"> s</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-3"> new school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">s.teachers </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1">//</span>
            <span className="qwerty-3"> first </span>
            <span className="qwerty-7">method </span>
            {"\n"}
            <span className="qwerty-1">//</span>
            <span className="qwerty-7">s.students</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1">//</span>
            <span className="qwerty-7">second method but don’t we use</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">start </span>
            <span className="qwerty-7">method </span>
            {"\n"}
            <span className="qwerty-5">teaching </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-multilevel-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-overloading">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csrelationbwclass;